import useAuth from "./useAuth";
import { refreshTokenAPI } from "../services/authService.js";
import { useCallback } from "react";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = useCallback(async () => {
    const response = await refreshTokenAPI();

    setAuth((prev) => {
      return {
        ...prev,
        id: response?.data?.user?.id,
        email: response?.data?.user?.email,
        firstName: response?.data?.user?.first_name,
        lastName: response?.data?.user?.last_name,
        role: response?.data?.user?.role,
        accessToken: response?.data?.access,
      };
    });

    return response?.data?.access;
  }, [setAuth]);

  return refresh;
};

export default useRefreshToken;
